import _extends from "@babel/runtime-corejs3/helpers/extends";
import PropTypes from 'prop-types';
import React from 'react';
import IconButton from './IconButton';
function AddCirclePlusButton(props) {
  return /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
    icon: "IconPlusCircle",
    onClick: props.addHandler
  }));
}
AddCirclePlusButton.propTypes = {
  ariaLabel: PropTypes.string,
  addHandler: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
AddCirclePlusButton.defaultProps = {
  labelText: 'add',
  ariaLabel: 'add',
  disabled: false
};
export default AddCirclePlusButton;
//# sourceMappingURL=AddCirclePlusButton.js.map